/*! Created by: Udo Schmal | https://www.gocher.me/ */
(function() {
  'use strict';
  function Slider(el) {
    var slider = el; // slider div
    var slides = el.querySelector('ul'); // slides ul list
    let language = document.documentElement.lang || 'en';
    let nextTxt, prevTxt, playTxt, pauseTxt, thumbTxt;
    switch (language.substr(0,2)) {
      case 'de':
        nextTxt = 'Nächster';
        prevTxt = 'Vorheriger';
        playTxt = 'Starten';
        pauseTxt = 'Anhalten';
        thumbTxt = 'Element';
        break;
      default:
        nextTxt = 'Next';
        prevTxt = 'Previous';
        playTxt = 'Play';
        pauseTxt = 'Pause';
        thumbTxt = 'Element';
        break;
    }
    if (!slides.classList.contains('slides')) {
      slides.classList.add('slides');
    }
    var items = slides.children; // slides li items
    if (items.length > 1) {
      var controls = null; // bubbles/thumbs ul list
      var controlItems = []; // bubbles/thumbs li items
      var prev = null; // previous div button
      var next = null; // next div button
      var play = null; // play and pause div button
      var active = 0; // active slide position counter
      var slideshow = null;
      var isAuto = true; // is triggered by autoplay event

      // get settings from dom
      var direction = el.classList.contains('vertical') ? 'vertical' : 'horizontal';
      if ((direction === 'horizontal') && !el.classList.contains('horizontal')) {
        el.classList.add('horizontal');
      }
      var fade = el.classList.contains('fade');
      var thumbs = false, bubbles = false, autoplay = false, arrows = false, playpause = false, loop = true;
      if (el.dataset.options) {
        thumbs = el.dataset.options.indexOf('thumbs') !== -1;
        bubbles = el.dataset.options.indexOf('bubbles') !== -1;
        autoplay = el.dataset.options.indexOf('autoplay') !== -1;
        arrows = el.dataset.options.indexOf('arrows') !== -1;
        playpause = el.dataset.options.indexOf('play_pause') !== -1;
        // loop = autoplay || (el.dataset.options.indexOf('loop') !== -1);
      }
      var interval = 3000;
      if (autoplay) {
        if (el.dataset.interval) {
          interval = parseInt(el.dataset.interval, 10);
          if (isNaN(interval)) {
            interval = 3000;
          }
        }
      }

      // set background image if no viewport support
      for(let i = 0; i < items.length; i++) {
        if (items[i].dataset.backgroundimage) {
          items[i].style.backgroundImage = "url('" + items[i].dataset.backgroundimage + "')";
        }
      }

      function activate (itemId) {
        isAuto = true;
        if (fade) {
          // fade in/out
          if (itemId >= items.length) {
            itemId = 0;
          } else if (itemId < 0) {
            itemId = items.length-1;
          }
          for (let i = 0; i < items.length; i++) {
            if (i == itemId) {
              items[i].classList.add('active');
              if (controls) {
                controlItems[i].classList.add('active');
              }
              active = i;
            } else {
              items[i].classList.remove('active');
              if (controls) {
                controlItems[i].classList.remove('active');
              }
            }
          }
        } else {
          // scroll into parent view
          el = items[itemId];
          if ('scrollBehavior' in document.documentElement.style) {
            slides.scrollTo({top: el.offsetTop, left: el.offsetLeft, behavior: 'smooth'});
          } else {
            slides.style.scrollSnapType = 'none';
            var top = el.offsetTop, left = el.offsetLeft, parent = el.parentNode, attr;
            attr = (direction === 'vertical' ? 'scrollTop' : 'scrollLeft');
            var from = parent[attr] || 0, to = (attr === 'scrollLeft' ? left : top);
            if (from === to) {
              return;
            }
            var start = Date.now();
            var tick = function () {
              var t = Math.min(1, ((Date.now() - start) / 1000));
              var eased =  t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
              var val = (eased * (to - from)) + from;
              parent[attr] = Math.floor(val);
              if (t<1) {
                window.requestAnimationFrame(tick);
              } else {
                slides.style.scrollSnapType = '';
              }
            };
            tick();
          }
        }
      }

      // add slide and snap scroll event (touch event)
      var scrollTimer;
      function startScroll() {
        if (isAuto) {
          isAuto = false;
        } else {
          if (slideshow) {
            pauseSlideshow();
          }
        }
        for (let i = 0; i < items.length; i++) {
          items[i].classList.remove('active');
          if (controls) {
            if (loop) {
              if (i>0 && i<items.length-1) {
                controlItems[i-1].classList.remove('active');
              }
            } else {
              controlItems[i].classList.remove('active');
            }
          }
        }
      }
      function stopScroll() {
        clearTimeout(scrollTimer);
        scrollTimer = null;
        // find new active slide
        let slidesCenter = {
          y: slides.scrollTop + slides.offsetHeight/2,
          x: slides.scrollLeft + slides.offsetWidth/2
        };
        for (let i = 0; i < items.length; i++) {
          if (items[i].offsetTop < slidesCenter.y &&
              items[i].offsetTop + items[i].offsetHeight > slidesCenter.y &&
              items[i].offsetLeft < slidesCenter.x &&
              items[i].offsetLeft + items[i].offsetWidth > slidesCenter.x) {
            let u = i;
            if (loop) {
              if (u === 0) {
                u = items.length-2;
              } else if (u === items.length-1) {
                u = 1;
              }
            }
            if (controls) {
              if (loop) {
                controlItems[u-1].classList.add('active');
              } else {
                controlItems[u].classList.add('active');
              }
            }
            if (!loop && arrows) {
              if (u === 0) {
                prev.classList.add('hidden');
              } else if (u === items.length-1) {
                next.classList.add('hidden');
              } else {
                prev.classList.remove('hidden');
                next.classList.remove('hidden');
              }
            }
            items[u].classList.add('active');
            if (i !== u) {
              isAuto = true;
              slides.style.scrollBehavior = 'auto';
              slides.scrollTo(items[u].offsetLeft, items[u].offsetTop);
              slides.style.scrollBehavior = '';
            }
            active = u;
            break;
          }
        }
      }
      function sliderScroll(event) {
        if (scrollTimer) {
          clearTimeout(scrollTimer);
        } else {
          startScroll();
        }
        scrollTimer = setTimeout(stopScroll, 100);
      }
      slides.addEventListener('scroll', sliderScroll);

      function scrollSnapFix() {
        slides.scrollLeft = items[active].offsetLeft;
      }
      // add slideshow
      var restartTimer;
      function startSlideshow () {
        if (restartTimer) {
          clearTimeout(restartTimer);
        }
        if (!slideshow) {
          slideshow = window.setInterval(function () {
            if (active+1 < items.length) {
              activate(++active);
            } else {
              activate(0);
            }
          }, interval);
        }
      }
      function stopSlideShow () {
        if (slideshow) {
          window.clearInterval(slideshow);
          slideshow = null;
        }
      }
      function pauseSlideshow () {
        if (slideshow) {
          window.clearInterval(slideshow);
          slideshow = null;
          restartTimer = setTimeout(startSlideshow, 5000);
        };
      }
      function toggleSlideshow (event) {
        if (play.classList.contains('play')) {
          startSlideshow();
          play.classList.remove('play');
          play.classList.add('pause');
          play.setAttribute('aria-label', pauseTxt);
        } else {
          stopSlideShow();
          play.classList.remove('pause');
          play.classList.add('play');
          play.setAttribute('aria-label', playTxt);
        }
      }
      if (autoplay) {
        startSlideshow();
      }

      // add play and pause button
      if (playpause) {
        play = document.createElement('div');
        play.className = autoplay ? 'pause' : 'play';
        play.setAttribute('tabindex', '0');
        play.setAttribute('role', 'button');
        play.setAttribute('aria-label', autoplay ? pauseTxt : playTxt);
        play.addEventListener('click', toggleSlideshow);
        el.appendChild(play);
      }

      // add mouse event listeners
      var posInitial, posLast, diff, threshold = 100;
      function dragStart(event) {
        diff = 0;
        event.preventDefault();
        if (direction == 'horizontal') {
          posInitial = slides.scrollLeft;
          posLast = event.clientX;
        } else {
          posInitial = slides.scrollTop;
          posLast = event.clientY;
        }
        slides.style.scrollSnapType = 'none';
        document.addEventListener('mouseup', dragEnd);
        slides.addEventListener('mousemove', dragAction);
      }
      function dragAction(event) {
        if (direction == 'horizontal') {
          diff = diff + (posLast - event.clientX);
          posLast = event.clientX;
          slides.scroll(posInitial + diff, 0);
        } else {
          diff = diff + (posLast - event.clientY);
          posLast = event.clientY;
          slides.scroll(0, posInitial + diff);
        }
      }
      function dragEnd(event) {
        slides.style.scrollSnapType = '';
        if (diff < -threshold) {
          activate(active-1);
        } else if (diff > threshold) {
          activate(active+1);
        } else {
          if (direction == 'horizontal') {
            slides.scroll(posInitial, 0);
          } else {
            slides.scroll(0, posInitial);
          }
        }
        document.removeEventListener('mouseup', dragEnd);
        slides.removeEventListener('mousemove', dragAction);
      }
      slides.addEventListener('mousedown', dragStart, true);

      // add control bubbles/thumbs
      if (bubbles || thumbs) {
        controls = document.createElement('ul');
        controls.classList.add('controls');
        controls.classList.add(thumbs ? 'thumbs' : 'bubbles');
        el.appendChild(controls);
        function controlClick(event) {
          if (autoplay) {
            pauseSlideshow();
          }
          let slide = this.dataset.slide;
          // respect clone slides
          if (!fade && loop) {
            slide++;
          }
          activate(slide);
        }
        for(let i = 0; i < items.length; i++) {
          let li = document.createElement('li');
          li.dataset.slide = i;
          li.setAttribute('tabindex', '0');
          li.setAttribute('role', 'button');
          li.setAttribute('aria-label', thumbTxt + ' ' + (i+1));
          if (thumbs) {
            let file = null;
            if (items[i].dataset.backgroundimage) {
              file = items[i].dataset.backgroundimage;
            } else {
              let img = items[i].querySelector('img');
              if (img) {
                if (img.src && (img.src != 'data:,')) {
                  file = img.src;
                } else if (img.dataset.src) {
                  file = img.dataset.src;
                }
              }
            }
            if (file) {
              li.style.backgroundImage = "url('" + file + "')";
            }
          }
          li.addEventListener('click', controlClick);
          controls.appendChild(li);
        }
        controlItems = controls.children;
        controlItems[active].classList.add('active');
      }

      // add previous and next button
      if (arrows) {
        prev = document.createElement('div');
        prev.className = 'prev';
        prev.setAttribute('tabindex', '0');
        prev.setAttribute('role', 'button');
        prev.setAttribute('aria-label', prevTxt);
        function prevClick() {
          if (autoplay) {
            pauseSlideshow();
          }
          activate(active-1);
        }
        prev.addEventListener('click', prevClick);
        el.appendChild(prev);

        next = document.createElement('div');
        next.className = 'next';
        next.setAttribute('tabindex', '0');
        next.setAttribute('role', 'button');
        next.setAttribute('aria-label', nextTxt);
        function nextClick() {
          if (autoplay) {
            pauseSlideshow();
          }
          activate(active+1);
        }
        next.addEventListener('click', nextClick);
        el.appendChild(next);
      }

      if (fade || !loop) {
        active = 0;
        if (arrows && !loop && prev) {
          prev.classList.add('hidden');
        }
      } else {
        // clone slides
        slides.appendChild(items[0].cloneNode(true));
        slides.insertBefore(items[items.length-2].cloneNode(true), items[0]);
        let figure = items[0].querySelector('figure');
        if (figure) {
          figure.classList.add('clone');
        }
        figure = items[items.length-1].querySelector('figure');
        if (figure) {
          figure.classList.add('clone');
        }
        // goto first slider item
        if (direction == 'vertical') {
          slides.scrollTo(0, slides.offsetHeight);
        } else {
          slides.scrollTo(slides.offsetWidth, 0);
        }
        active = 1;
      }
      activate(active);
    } else {
      if (items.length > 0) {
        items[0].classList.add('active');
      }
    }
  }

  var els = document.querySelectorAll("div[data-type='slider']"), cnt = els.length, i;
  if (els.length > 0) {
    for (i=0; i < cnt; i++) {
      new Slider(els[i]);
    }
    // accessibility: handle tabindex enter keydown event
    document.addEventListener('keydown', function(event) {
      if (event.key === "Enter") {
        if ((event.target.parentNode && event.target.parentNode.classList.contains('controls')) ||
            event.target.classList.contains('prev') ||
            event.target.classList.contains('next') ||
            event.target.classList.contains('pause') ||
            event.target.classList.contains('play')) {
          event.target.click();
        }
      }
    });
  }
})();
